var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectTopupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1772_644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1772_644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6668 27.6666L29.4168 15.9166L27.0835 13.5833L17.6668 23L12.9168 18.25L10.5835 20.5833L17.6668 27.6666ZM20.0002 36.6666C17.6946 36.6666 15.5279 36.2291 13.5002 35.3541C11.4724 34.4791 9.7085 33.2916 8.2085 31.7916C6.7085 30.2916 5.521 28.5278 4.646 26.5C3.771 24.4722 3.3335 22.3055 3.3335 20C3.3335 17.6944 3.771 15.5278 4.646 13.5C5.521 11.4722 6.7085 9.70831 8.2085 8.20831C9.7085 6.70831 11.4724 5.52081 13.5002 4.64581C15.5279 3.77081 17.6946 3.33331 20.0002 3.33331C22.3057 3.33331 24.4724 3.77081 26.5002 4.64581C28.5279 5.52081 30.2918 6.70831 31.7918 8.20831C33.2918 9.70831 34.4793 11.4722 35.3543 13.5C36.2293 15.5278 36.6668 17.6944 36.6668 20C36.6668 22.3055 36.2293 24.4722 35.3543 26.5C34.4793 28.5278 33.2918 30.2916 31.7918 31.7916C30.2918 33.2916 28.5279 34.4791 26.5002 35.3541C24.4724 36.2291 22.3057 36.6666 20.0002 36.6666Z",
    fill: "#32BA7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTopupIcon);
export default __webpack_public_path__ + "static/media/select-topup-icon.6e5da4d50942f04a7b1b9d0b77016e9a.svg";
export { ForwardRef as ReactComponent };